export default {
    defaultLang: 'it'
}
